import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  getListTimeKeepingManagerStart,
  getListTimeKeepingManagerSuccess,
  getListTimeKeepingManagerFailed,
} from "../redux/getListTimeKeepingManager";

import { SCREEN } from "helper/roleChecker/Screens";
import { formFilterTimeKeepingManagerSelector } from "../redux/selector";
import { getListTimeKeepingManagerApi } from "core/http/service/timeKeeping";

function* getListTimeKeepingManagerWork() {
  const form = yield select(formFilterTimeKeepingManagerSelector);

  const params = { ...form };
  try {
    const res = yield call(getListTimeKeepingManagerApi, {
      ...params,
      screenCode: SCREEN.IP_019,
    });
    yield put({
      type: getListTimeKeepingManagerSuccess.type,
      payload: {
        data: res.data,
        categoryName: res.categoryName,
        totalRecords: res.totalRecords,
      },
    });
  } catch (error: any) {
    yield put({
      type: getListTimeKeepingManagerFailed.type,
    });
  }
}

function* watchGetListTimeKeepingManager() {
  yield takeLatest(
    getListTimeKeepingManagerStart.type,
    getListTimeKeepingManagerWork
  );
}

export default function* getListTimeKeepingManagerSaga() {
  yield all([watchGetListTimeKeepingManager()]);
}
